export default "__VITE_ASSET__CWCOv9lG__"